<template>
  <b-container v-if="evaluationData">
    <template-evaluation-navigation-buttons
      v-if="getSelectedRequirement"
      :is-previous-enabled="isPreviousEnabled"
      :is-next-enabled="isNextEnabled"
      @moveEvaluatingNode="moveEvaluatingNode"
      @clearEvaluatingNode="clearEvaluatingNode"
    />

    <div v-show="!getSelectedRequirement">
      <div class="mt-2">
        <div>
          <b-row style="margin-top: 10px; margin-bottom: 30px">
            <b-col>
              <div class="d-flex flex-row">
                <div v-for="(tag, index) in tags" :key="index">
                  <b-button
                    :class="isButtonSelected(tag.value)"
                    squared
                    :style="tag.style"
                    @click="filter = tag.value"
                  >
                    <div v-if="tag.black" style="color: black">
                      {{ $t(tag.label) }}
                    </div>
                    <div v-else>
                      {{ $t(tag.label) }}
                    </div>
                  </b-button>
                </div>
                <b-button
                  v-if="availableForResubmition"
                  :class="
                    isButtonSelected(
                      'label_evaluation_evidencesRequested_status_resubmit'
                    )
                  "
                  style="background: #86a5dd !important"
                  squared
                  @click="
                    filter =
                      'label_evaluation_evidencesRequested_status_resubmit'
                  "
                >
                  <div style="color: black">
                    {{
                      $t("label_evaluation_evidencesRequested_status_resubmit")
                    }}
                  </div>
                </b-button>
              </div>
            </b-col>
            <b-col style="position: relative; height: 50px;">
              <b-row>
                <b-col style="text-align: right; scale: 0.9" cols="8">
                  <span class="dot" style="background: #3ece0f" />
                  <span>
                    {{
                      $t(
                        "label_evaluation_evidencesRequested_evidence_colorCode"
                      )
                    }}
                  </span>
                  <span class="dot" style="background: #1581f7" />
                  <span>
                    {{
                      $t("label_evaluation_evidencesRequested_shared_colorCode")
                    }}
                  </span>
                  <span
                    class="dot"
                    style="background: none; border: 1px solid #1e4380"
                  />
                  <span>
                    {{
                      $t(
                        "label_evaluation_evidencesRequested_comment_colorCode"
                      )
                    }}
                  </span>
                </b-col>
                <b-col cols="4">
                  <b-btn
                    v-if="data"
                    style="position: absolute; right: 0px; font-size: 0.95rem;"
                    :disabled="
                      !evaluationData ||
                      !evaluationData.readyToSendEvidences ||
                      evaluationData.evaluation.evidencesSubmitted
                    "
                    :variant="
                      evaluationData && evaluationData.readyToSendEvidences
                        ? 'third'
                        : 'secondary'
                    "
                    @click="
                      showModal = true;
                      evidencesSent = false;
                    "
                  >
                    {{
                      $t("label_evaluation_evidencesRequested_submitForReview")
                    }}
                  </b-btn>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr style="margin-top: -35px" />
        </div>
        <div>
          <h4>
            {{ evaluationData.evaluation_administrator_model_name }}
          </h4>

          <b-container>
            <b-row>
              <b-col cols="8">
                <h4  class="text-left">
                  {{
                    $t(
                      "label_evaluation_evidencesRequested_evidences_row_title"
                    )
                  }}
                </h4>
              </b-col>
              <b-col cols="1">
                <h4 class="text-center">
                  {{
                    $t("label_evaluation_evidencesRequested_status_row_title")
                  }}
                </h4>
              </b-col>
              <b-col cols="1">
                <h4  class="text-center">
                  {{ $t("label_evaluation_evidencesRequested_quantity_table") }}
                </h4>
              </b-col>
              <b-col cols="2">
                <h4  class="text-left">
                  {{
                    $t(
                      "label_evaluation_evidencesRequested_lastUpdated_row_title"
                    )
                  }}
                </h4>
              </b-col>
            </b-row>
            <b-row v-if="!getSelectedRequirement && filteredData">
              <evaluation-organization-tree-list
                :key="lastEvaluated"
                :model="filteredData"
                default-tree-node-name="new node"
                :account="account"
                :evaluation-id="evaluationId"
                :level="0"
                :is-submitted="isSubmitted"
                :filter="filter"
                default-leaf-node-name="new leaf"
                @updatePath="updatePath"
              />
            </b-row>
          </b-container>
        </div>
      </div>

    </div>
    <b-row v-if="getSelectedRequirement">
      <b-col class="mt-2">
        <evaluation-evaluate-node-organization
          :evaluation-id="evaluationId"
          :status="status"
          @clearEvaluatingNode="clearEvaluatingNode"
        />
      </b-col>
    </b-row>

    <b-modal
      v-if="filteredData"
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      :title="$t('label_evaluation_evidencesRequested_confirmation_title')"
    >
      <div v-if="!evidencesSent">
        <div style="color: red; padding: 20px">
          {{ $t("label_evaluation_evidencesRequested_confirmation_warning") }}
        </div>
        <div style="padding: 20px">
          {{
            $t("label_evaluation_evidencesRequested_confirmation_disclaimer")
          }}
        </div>
        <div style="padding: 20px">
          <input
            v-model="ready"
            type="checkbox"
            name="check-button"
            switch
            size="lg"
          />
          <span class="businessName">
            {{
              $t(
                "label_evaluation_evidencesRequested_confirmation_checkBox_description"
              )
            }}
          </span>
        </div>
      </div>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-btn
          v-if="!evidencesSent"
          variant="primary"
          :disabled="!ready"
          @click="evidencesReady(data)"
        >
          {{ $t("label_evaluation_submit_button") }}
        </b-btn>
      </div>
      <div v-if="evidencesSent">
        {{ $t("label_evaluation_evidencesRequested_sentConfirmation") }}
      </div>
    </b-modal>
    <template-evaluation-navigation-buttons
      v-if="getSelectedRequirement"
      :is-previous-enabled="isPreviousEnabled"
      :is-next-enabled="isNextEnabled"
      style="margin-bottom: 30px"
      @moveEvaluatingNode="moveEvaluatingNode"
      @clearEvaluatingNode="clearEvaluatingNode"
    />
  </b-container>
</template>
<script>
import EvaluationOrganizationTreeList from "./EvaluationOrganizationTreeList";
import EvaluationEvaluateNodeOrganization from "./EvaluationEvaluateNodeOrganization";
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";

import evaluationDataMixin from "@/components/modules/evaluation/mixins/evaluationDataMixin";
import { cloneDeep } from "lodash";

export default {
  name: "EvaluationOrganization",
  components: {
    EvaluationEvaluateNodeOrganization,
    EvaluationOrganizationTreeList,
  },
  mixins: [evaluationDataMixin],
  data: function () {
    return {
      evidencesSent: false,
      showModal: false,
      path: [],
      ready: false,
      activateButton: false,
      evaluationId: this.$route.params.idEvaluation,
      evaluationData: { evaluation: {} },
      status: "success",
      filter: "",
      isDisabled: false,
      isSubmitted: false,
      filteredData: [],
      availableForResubmition: false,
      tags: [
        {
          label: "label_evaluation_evidencesRequested_all_filter",
          value: "",
          style: "background:#1e4380 !important;",
        },
        {
          label: "label_evaluation_evidencesRequested_status_ready",
          value: "label_evaluation_evidencesRequested_status_ready",
          style: "background:#009355 !important",
        },
        {
          label: "label_evaluation_evidencesRequested_status_inProgress",
          value: "label_evaluation_evidencesRequested_status_inProgress",
          style: "background:#ffbe00 !important",
          black: true,
        },
        {
          label: "label_evaluation_evidencesRequested_status_pending",
          value: "label_evaluation_evidencesRequested_status_pending",
          style: "background:#cbd2d3 !important;",
          black: true,
        },
      ],
    };
  },
  computed: mapGetters(["getLang", "getSelectedRequirement"]),
  async created() {
    this.$store.commit("CLEAR_EVALUATION_STORE");
    this.evidencesRequested = true;
    await this.loadData();
  },
  methods: {
    loadData: async function () {
      this.$store.commit("SET_IS_ORGANIZATION", true);
      await this.getEvaluations();
    },
    processData() {
      this.data = this.filterNodesThatRequireEvidences(this.data);
      this.disableRequirements(this.data);
      this.filteredData = cloneDeep(this.data);
    },
    filterNodesThatRequireEvidences(eva) {
      if (eva?.children) {
        var filteredChildren = [];
        for (var i = 0; i < eva.children.length; i++) {
          var temp = this.filterNodesThatRequireEvidences(eva.children[i]);
          if (typeof temp != "undefined") {
            filteredChildren.push(temp);
          }
        }
        if (filteredChildren.length > 0) {
          eva.children = filteredChildren;
          return eva;
        } else {
          return undefined;
        }
      } else if (!eva?.children || eva?.children.length == 0) {
        if (
          eva?.evaluation_administrator_node_editRequirement_evidencesReady ==
          "label_evaluation_evidencesRequested_status_resubmit"
        ) {
          this.availableForResubmition = true;
        }
        if (
          eva?.evaluation_administrator_node_editRequirement_requireEvidences
        ) {
          return eva;
        } else {
          return undefined;
        }
      }
    },

    disableRequirements(eva) {
      if (eva) {
        eva.submitted = false;
        if (eva.children) {
          var disableParent = true;
          for (var i = 0; i < eva.children.length; i++) {
            var temp = this.disableRequirements(eva.children[i]);
            if (temp == false) {
              disableParent = false;
            }
          }
          if (disableParent == true) {
            eva.submitted = true;
            return true;
          } else {
            return false;
          }
        } else if (!eva.children || eva.children.length == 0) {
          if (
            eva.evaluation_administrator_node_editRequirement_evidencesReady ==
              "label_evaluation_evidencesRequested_status_resubmitted" ||
            eva.evaluation_administrator_node_editRequirement_evidencesReady ==
              "label_evaluation_evidencesRequested_status_submitted"
          ) {
            eva.submitted = true;
            return true;
          } else {
            return false;
          }
        }
      }
    },

    isButtonSelected(value) {
      if (value === this.filter) {
        return "tagButton selected";
      } else {
        return "tagButton";
      }
    },

    createFormData(file) {
      const data = new FormData();
      data.append("title", file.title);
      data.append("name", file.name);
      data.append("description", file.description);
      data.append("evaluationId", file.evaluationId);
      data.append("requirementId", file.requirement.id);
      data.append("url", file.url);

      return data;
    },
    async evidencesReady(node) {
      this.isSubmitted = true;
      let valuesToUpdate = this.changeStatus(
        this.getSelectedEvaluation.evaluation,
        [],
        {}
      );
      valuesToUpdate[`evidencesSubmittedFirstTime`] = true;
      valuesToUpdate[`evidencesSubmitted`] = true;

      await axiosCall({
        url:
          "Evaluations/envidencesReady/" +
          this.getLang +
          "/" +
          this.evaluationId +
          "/1",
        method: "POST",
        data: { account: this.getUserAccount },
      })
        .then(async () => {
          await this.$store.dispatch("updateEvaluation", { valuesToUpdate });
          this.evidencesSent = true;
        })
        .catch(() => {
        });
    },
    changeStatus(node, path, fieldsToUpdate) {
      let newFieldsToUpdate = { ...fieldsToUpdate };

      if (
        node.evaluation_administrator_node_editRequirement_requireEvidences &&
        ["label_evaluation_evidencesRequested_status_ready"].includes(
          node.evaluation_administrator_node_editRequirement_evidencesReady
        )
      ) {
        let basePath = "";
        path.forEach((p, index) => {
          basePath += `${index === 0 ? "" : "."}children.${p}`;
        });
        newFieldsToUpdate[
          `${basePath}.evaluation_administrator_node_editRequirement_evidencesReady`
        ] = node.resubmission
          ? "label_evaluation_evidencesRequested_status_resubmitted"
          : "label_evaluation_evidencesRequested_status_submitted";
      }

      if (node.children && node.children.length > 0) {
        node.children.map((child, index) => {
          newFieldsToUpdate = {
            ...this.changeStatus(child, [...path, index]),
            ...newFieldsToUpdate,
          };
        });
      }
      return newFieldsToUpdate;
    },
    updatePath(path) {
      path.reverse();
      this.path = path;
    },
  },
};
</script>

<style lang="scss" scoped>
h4 {
  font-size: 1.2rem;
  text-transform: uppercase;
}
@import "../../../../assets/css/variables";

.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  position: static;
}
button.btn.tagButton {
  border: none;
  width: 115px;
  height: 40px;
  font-size: 0.9rem;
  &:focus {
    outline: none;
  }
  &:hover {
    height: 45px;
    border-bottom: 5px solid #acacac;
  }
  &.selected {
    height: 45px;
    border-bottom: 5px solid black;
  }
}
.cardContainer {
  border: 1px solid #000000;
  width: 100%;
  padding: 30px 40px;
}
.cardContainer h5 {
  text-align: center;
  width: 100%;
}
h2 {
  color: black;
  margin: 1em 0;
}
.label {
  font-weight: bold;
  font-size: 14px;
}
h7 {
  font-weight: bold;
}
</style>
